import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles(() => ({
    label: {
      marginBottom: 10,
    },
  }));
